module.exports = __webpack_public_path__ + "img/分组 9.da6f061d.png";